module.exports = __webpack_public_path__ + "img/9816334.cd023b9c.png";